import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 auth_sign_out: { message: "idle" },
};

export const auth_sign_out_Slice = createSlice({
 name: "auth_sign_out",
 initialState,
 reducers: {
  success_auth_sign_out: (state, action) => {
   state.auth_sign_out = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_auth_sign_out: (state, action) => {
   state.auth_sign_out = { status: app_consts.FAIL, message: action.payload };
  },
  reset_auth_sign_out: (state) => {
   state.auth_sign_out = { status: app_consts.IDLE };
  },
  loading_auth_sign_out: (state) => {
   state.auth_sign_out = { status: app_consts.LOADING };
  },
 }
});

export const { success_auth_sign_out, fail_auth_sign_out, reset_auth_sign_out, loading_auth_sign_out } = auth_sign_out_Slice.actions;

export default auth_sign_out_Slice.reducer;